export default __webpack_public_path__ + "static/media/markerSelect.de52e941.svg";